import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { Button } from 'antd';
import FullscreenApi from 'src/utils/FullscreenHelper';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

interface FullscreenToggleProps extends LocalizeContextProps { }

interface FullscreenToggleState {
    isFullscreen: boolean;
}

class FullscreenToggle extends React.Component<FullscreenToggleProps, FullscreenToggleState> {
    constructor(props: FullscreenToggleProps) {
        super(props);
        bindAllOfThis(this, FullscreenToggle.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
            isFullscreen: false
        };
    }

    componentDidMount() {
        document.addEventListener("fullscreenchange", this.fullscreenEventListener);
        document.addEventListener("mozfullscreenchange", this.fullscreenEventListener);
        document.addEventListener("webkitfullscreenchange", this.fullscreenEventListener);
        document.addEventListener("msfullscreenchange", this.fullscreenEventListener);

        this.fullscreenEventListener();
    }

    componentWillUnmount() {
        document.removeEventListener("fullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("mozfullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("webkitfullscreenchange", this.fullscreenEventListener);
        document.removeEventListener("msfullscreenchange", this.fullscreenEventListener);
    }

    // componentWillReceiveProps() {
    //     this.fullscreenEventListener();
    // }

    fullscreenEventListener() {
        let isFullscreen = FullscreenApi.GetFullscreenValue();
        this.setState({
            isFullscreen: isFullscreen
        } as FullscreenToggleState);
    }

    toggleFullscreen(e: any) {
        if (this.state.isFullscreen) {
            FullscreenApi.CancelFullscreen();
        } else {
            FullscreenApi.RequestFullscreen(document.body);
        }
    }

    renderButtonText() {
        if (this.state.isFullscreen) {
            return <Translate id="admin.header.exitFullscreenButton" />;
        }
        return <Translate id="admin.header.enterFullscreenButton" />;
    }

    render() {
        return <Button tabIndex={2} type="primary" onClick={this.toggleFullscreen}>{this.renderButtonText()}</Button>;
    }
}

export default withLocalize(FullscreenToggle);



// WEBPACK FOOTER //
// ./src/components/common/FullscreenToggle.tsx